<div class="find-a-background-web">
    <div class="search-breadcrumb ">
        <div class="search-breadcrumb-item" (click)="clearSearch()">{{breadcrumbText}}</div>
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div *ngIf="locale !== 'es-US' && queryNameOrSpecialty !== '' && queryNameOrSpecialty !== null && showSpinner === false" class="search-breadcrumb-item-2">{{breadcrumbText2}} "{{queryNameOrSpecialty}}"</div>
        <div *ngIf="locale === 'es-US' && queryNameOrSpecialty !== '' && queryNameOrSpecialty !== null && showSpinner === false" class="search-breadcrumb-item-2">{{breadcrumbText2}} "{{queryNameOrSpecialty}}"</div>
        <div *ngIf="queryNameOrSpecialty === '' || queryNameOrSpecialty === null || showSpinner === true" class="search-breadcrumb-item-2">{{breadcrumbText2}}</div> 
    </div>
    <div *ngIf="queryNameOrSpecialty !== '' && queryNameOrSpecialty !== null && showSpinner === false" class="search-results-title-web">{{breadcrumbText2}} "{{queryNameOrSpecialty}}"</div>
    <div *ngIf="queryNameOrSpecialty === '' || queryNameOrSpecialty === null || showSpinner === true" class="search-results-title-web">{{breadcrumbText2}}</div>
    <hr style="margin: 0px 2.52rem; border: 1px solid #E0E0E0;">
    <div>
        <div *ngIf="showSpinner === false" class="filter-bar-container-web">
            <div class="filter-bar-left-web" [matMenuTriggerFor]="menu">
                 <div style="display: flex; align-items: center; justify-content: center; margin-right: 6px;">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.9514 0L7.64368 13.1333L5.83571 7.35412L0.000118644 5.73751L12.9514 0Z" fill="#959595"/>
                    </svg>
                 </div>
                <div>{{queryCityOrZip}} ({{getDistanceInMilesFromSliderValue(distanceSliderValue)}} {{mileText}})</div>
                <div style="display: flex; align-items: center; justify-content: center; margin-left: 5px;">
                    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 0H0L4.76471 4.5L9 0Z" fill="#8B8B8B"/>
                    </svg>
                </div>    
            </div>
            <mat-menu #menu="matMenu" yPosition="below" xPosition="after" class="menu-container" (closed)="onLocationMenuClosed()">
                <div (click)="$event.stopPropagation()">
                    <div class="menu-row-1">
                        <div class="menu-label-location ">{{locationLabel}}</div>
                        <div class="menu-btn-clear" (click)="onClearLocationFilter()">{{clearBtnText}}</div>
                    </div>
                    <div class="menu-row-2">
                        <input class="menu-input-location" 
                            [formControl]="cityOrZipControl" 
                            type="text"
                            [matAutocomplete]="cityAuto">
                        <mat-autocomplete #cityAuto="matAutocomplete" class="autocomplete-panel-below">
                            <mat-option *ngFor="let option of filteredCityOptions$ | async" [value]="option">
                                {{option}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div class="menu-row-3">
                        <div>{{distanceLabel}} ({{mileText}})</div>
                    </div>
                    <div class="menu-row-4">
                        <div class="distance-slider-container">
                            <input type="range" min="0" max="4" step="1" [(ngModel)]="distanceSliderValue" class="distance-slider">
                            <div class="distance-labels">
                                <span style="left:0%; cursor: pointer;" (click)="setDistanceSliderValueFromLabel(0)">5</span>
                                <span style="left:21%; cursor: pointer;" (click)="setDistanceSliderValueFromLabel(1)">10</span>
                                <span style="left:44%; cursor: pointer;" (click)="setDistanceSliderValueFromLabel(2)">15</span>
                                <span style="left:67%; cursor: pointer;" (click)="setDistanceSliderValueFromLabel(3)">25</span>
                                <span style="left:90%; cursor: pointer;" (click)="setDistanceSliderValueFromLabel(4)">50</span>
                            </div>
                        </div>
                    </div>
                    <div class="menu-row-5">
                        <button class="menu-btn-apply" (click)="onApplyLocationFilter()">{{applyBtnText}}</button>
                    </div>
                </div>
            </mat-menu>
            <div class="filter-bar-right-web">
                <div class="filter-sort-toggle-web" [matMenuTriggerFor]="sortMenu">
                    <div style="display: flex; align-items: center; justify-content: center;">
                        <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.282 8.52091H28.2858M17.282 14.7113H25.1419M17.282 20.9018H21.9979M7.4645 7.71436V23.1429M7.4645 23.1429L2.57153 18.4266M7.4645 23.1429L12.5443 18.4266" stroke="#33006F" stroke-width="2.57143" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                <mat-menu #sortMenu="matMenu" yPosition="below" xPosition="before" class="sort-menu-container">
                    <div (click)="$event.stopPropagation()">
                        <div class="menu-label-sort">
                            {{sortByTitle}}
                        </div>
                        <div class="menu-radio-option">
                            <input type="radio" 
                                id="sort-distance" 
                                name="providerSort" 
                                value="distance" 
                                [(ngModel)]="providerSortMethod" 
                                (change)="onApplySortMethod('distance')">
                            <label for="sort-distance">{{distanceLabel}}</label>
                        </div>
                        <div class="menu-radio-option">
                            <input type="radio" 
                                   id="sort-availability" 
                                   name="providerSort" 
                                   value="availability" 
                                   [(ngModel)]="providerSortMethod" 
                                   (change)="onApplySortMethod('availability')">
                            <label for="sort-availability">{{availabilityLabel}}</label>
                        </div>
                        <div class="menu-radio-option">
                            <input type="radio" 
                                   id="sort-name" 
                                   name="providerSort" 
                                   value="name" 
                                   [(ngModel)]="providerSortMethod" 
                                   (change)="onApplySortMethod('name')">
                            <label for="sort-name">{{nameLabel}}</label>
                        </div>
                    </div>
                </mat-menu>
                <div class="filter-display-toggle-web" [class.selected]="(providerSearchFilterToggle$ | async)" (click)="searchState.toggleProviderSearchFilter()">
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.4287 9L25.7144 9" stroke="#33006F" stroke-width="2.57143" stroke-linecap="round"/>
                        <path d="M5.14307 9L10.2859 9" stroke="#33006F" stroke-width="2.57143" stroke-linecap="round"/>
                        <path d="M21.8569 21.8572L25.7141 21.8572" stroke="#33006F" stroke-width="2.57143" stroke-linecap="round"/>
                        <path d="M5.14307 21.8572L15.4288 21.8572" stroke="#33006F" stroke-width="2.57143" stroke-linecap="round"/>
                        <circle cx="12.8573" cy="8.9999" r="2.57143" transform="rotate(90 12.8573 8.9999)" stroke="#33006F" stroke-width="2.57143" stroke-linecap="round"/>
                        <circle cx="19.2855" cy="21.8571" r="2.57143" transform="rotate(90 19.2855 21.8571)" stroke="#33006F" stroke-width="2.57143" stroke-linecap="round"/>
                    </svg>
                    <div *ngIf="appliedFilterCount > 0" class="filter-display-toggle-count-web">{{appliedFilterCount}}</div>
                </div>
            </div>
        </div>
        <div class="search-results-count-web">
            <div *ngIf="showSpinner === false">
                {{resultsText}} ({{(providerSearchResults$ | async)?.length}})
            </div>  
        </div>
        <div *ngIf="showSpinner === true" >
            <div class="spinner-container-web" style="padding-left: 2.52rem;">
                <mat-spinner diameter="70"></mat-spinner>
            </div>
        </div>        
        <div *ngIf="showSpinner === false" class="search-results-list-web">
            <div *ngFor="let provider of getPaginatedResults()">
                <app-provider-search-results-card
                    [provider]="provider"
                    [currentLocation]="currentLocation"
                    [queryCityOrZip]="queryCityOrZip">
                </app-provider-search-results-card>
            </div>
        </div>
        <br>
        <div style="display: flex; justify-content: end; padding: 24px 2.52rem; ">
            <div *ngIf="showSpinner === false" class="search-results-pagination-web">
                <div class="custom-arrow" (click)="goToPreviousPage()" [style.cursor]="currentPage > 1 ? 'pointer' : 'default'" [style.opacity]="currentPage > 1 ? '1' : '0.5'">
                    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.11622 1.43945L1.43945 9.11622L9.11622 16.793" stroke="#959595" stroke-width="2.87879" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <button *ngFor="let page of visiblePages" 
                        [class.search-results-pagination-btn-web-selected]="page === currentPage"
                        [class.search-results-pagination-btn-web-unselected]="page !== currentPage"
                        (click)="goToPage(page)">
                    {{page}}
                </button>
                <div class="custom-arrow" (click)="goToNextPage()" [style.cursor]="currentPage < totalPages ? 'pointer' : 'default'" [style.opacity]="currentPage < totalPages ? '1' : '0.5'">
                    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.43944 16.793L9.11621 9.1162L1.43944 1.43943" stroke="#959595" stroke-width="2.87879" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</div>
